import _classCallCheck from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import * as asn1js from "asn1js";
import { getParametersValue, toBase64, arrayBufferToString, stringToArrayBuffer, fromBase64, nearestPowerOf2, clearProps } from "pvutils"; //**************************************************************************************

/**
 * Class from RFC3447
 */

var RSAPublicKey = /*#__PURE__*/function () {
  //**********************************************************************************

  /**
   * Constructor for RSAPublicKey class
   * @param {Object} [parameters={}]
   * @param {Object} [parameters.schema] asn1js parsed value to initialize the class from
   * @property {Integer} [modulus]
   * @property {Integer} [publicExponent]
   */
  function RSAPublicKey() {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RSAPublicKey);

    //region Internal properties of the object

    /**
     * @type {Integer}
     * @desc Modulus part of RSA public key
     */
    this.modulus = getParametersValue(parameters, "modulus", RSAPublicKey.defaultValues("modulus"));
    /**
     * @type {Integer}
     * @desc Public exponent of RSA public key
     */

    this.publicExponent = getParametersValue(parameters, "publicExponent", RSAPublicKey.defaultValues("publicExponent")); //endregion
    //region If input argument array contains "schema" for this object

    if ("schema" in parameters) this.fromSchema(parameters.schema); //endregion
    //region If input argument array contains "json" for this object

    if ("json" in parameters) this.fromJSON(parameters.json); //endregion
  } //**********************************************************************************

  /**
   * Return default values for all class members
   * @param {string} memberName String name for a class member
   */


  _createClass(RSAPublicKey, [{
    key: "fromSchema",
    //**********************************************************************************

    /**
     * Convert parsed asn1js object into current class
     * @param {!Object} schema
     */
    value: function fromSchema(schema) {
      //region Clear input data first
      clearProps(schema, ["modulus", "publicExponent"]); //endregion
      //region Check the schema is valid

      var asn1 = asn1js.compareSchema(schema, schema, RSAPublicKey.schema({
        names: {
          modulus: "modulus",
          publicExponent: "publicExponent"
        }
      }));
      if (asn1.verified === false) throw new Error("Object's schema was not verified against input data for RSAPublicKey"); //endregion
      //region Get internal properties from parsed schema

      this.modulus = asn1.result.modulus.convertFromDER(256);
      this.publicExponent = asn1.result.publicExponent; //endregion
    } //**********************************************************************************

    /**
     * Convert current object to asn1js object and set correct values
     * @returns {Object} asn1js object
     */

  }, {
    key: "toSchema",
    value: function toSchema() {
      //region Construct and return new ASN.1 schema for this object
      return new asn1js.Sequence({
        value: [this.modulus.convertToDER(), this.publicExponent]
      }); //endregion
    } //**********************************************************************************

    /**
     * Convertion for the class to JSON object
     * @returns {Object}
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        n: toBase64(arrayBufferToString(this.modulus.valueBlock.valueHex), true, true, true),
        e: toBase64(arrayBufferToString(this.publicExponent.valueBlock.valueHex), true, true, true)
      };
    } //**********************************************************************************

    /**
     * Convert JSON value into current object
     * @param {Object} json
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      if ("n" in json) {
        var array = stringToArrayBuffer(fromBase64(json.n, true));
        this.modulus = new asn1js.Integer({
          valueHex: array.slice(0, Math.pow(2, nearestPowerOf2(array.byteLength)))
        });
      } else throw new Error("Absent mandatory parameter \"n\"");

      if ("e" in json) this.publicExponent = new asn1js.Integer({
        valueHex: stringToArrayBuffer(fromBase64(json.e, true)).slice(0, 3)
      });else throw new Error("Absent mandatory parameter \"e\"");
    } //**********************************************************************************

  }], [{
    key: "defaultValues",
    value: function defaultValues(memberName) {
      switch (memberName) {
        case "modulus":
          return new asn1js.Integer();

        case "publicExponent":
          return new asn1js.Integer();

        default:
          throw new Error("Invalid member name for RSAPublicKey class: ".concat(memberName));
      }
    } //**********************************************************************************

    /**
     * Return value of pre-defined ASN.1 schema for current class
     *
     * ASN.1 schema:
     * ```asn1
     * RSAPublicKey ::= Sequence {
     *    modulus           Integer,  -- n
     *    publicExponent    Integer   -- e
     * }
     * ```
     *
     * @param {Object} parameters Input parameters for the schema
     * @returns {Object} asn1js schema object
     */

  }, {
    key: "schema",
    value: function schema() {
      var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      /**
       * @type {Object}
       * @property {string} utcTimeName Name for "utcTimeName" choice
       * @property {string} generalTimeName Name for "generalTimeName" choice
       */
      var names = getParametersValue(parameters, "names", {});
      return new asn1js.Sequence({
        name: names.blockName || "",
        value: [new asn1js.Integer({
          name: names.modulus || ""
        }), new asn1js.Integer({
          name: names.publicExponent || ""
        })]
      });
    }
  }]);

  return RSAPublicKey;
}(); //**************************************************************************************


export { RSAPublicKey as default };